<div class="image-container">
  <div *ngFor="let image of imageUrls" class="image-wrapper">
    <ng-container  *ngIf="!isViewMode">
      <input type="checkbox" [(ngModel)]="image.selected" (change)="onCheckboxChange(image.id,image.name)">
    </ng-container>
    <img [src]="image.url" alt="Image" class="fixed-size">
    <p>{{ image.name }}</p>
  </div>

  <div *ngFor="let document of documentUrls" class="document-wrapper">
    <ng-container *ngIf="!isViewMode">
      <input type="checkbox" [(ngModel)]="document.selected" (change)="onCheckboxChange(document.id, document.name)">
    </ng-container>
    <img src="\assets\img\doc.png" alt="Document" class="fixed-size">
    <p>{{ document.name }}</p>
    <a [href]="document.url" download="{{ 'document.' + document.extension }}">Download</a>
  </div>
</div>

<div *ngIf="imageUrls.length === 0 && documentUrls.length === 0" class="loader-container">
  <mat-spinner *ngIf="showLoader" [fullScreen]="false" diameter="50" strokeWidth="5"></mat-spinner>
  <p *ngIf="!showLoader">No images or documents available.</p>
</div>

<br>

<div class="button-container">
  <button mat-button class="delete-button" *ngIf="selectedItems" (click)="deleteImg()">Delete</button>
  <button mat-button class="cancel-button" (click)="cancel()">Cancel</button>
</div>
  